module.exports = function getResource(label, vars = []) {
    let resources = {
        sephoraCard: 'Sephora Card',
        sephoraTempCard: 'Sephora Temp Card',
        sephoraVisaCard: 'Sephora VISA Card',
        sephoraVisaTempCard: 'Sephora VISA Temp Card'
    };

    return resources[label];
};
